import React, { useState } from 'react';
import { useQuery } from 'react-query';
import {
  CountTitle,
  DashboardCard,
  DashboardCardContainer,
  DashboardContainer,
  DashboardContainerLeft,
  DashboardContainerRight,
  DashboardContainerRightTitle,
  DashboardCountCard,
  DashboardCountCardLeft,
  DashboardCountCardRight,
  DashboardCountContainer,
  DashboardCountContainerLeft,
  DashboardCountContainerRight,
  DashboardCountView,
  DashboardHeaderContainer,
  DashboardHeaderTitle,
  DashboardTableContainer,
  DashboardTableContent,
  DashboardTableView,
  Image,
  ImageWrapper,
  LabelCount,
  LogoTitle,
} from './dashboard.style';
import { Label } from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import DateUtils from '../../../utils/date-utils';
import * as UserService from '../../../services/bioplus-services/user';
import LogbookService from '../../../services/bioplus-services/logBook';
import CompanyService from '../../../services/bioplus-services/company';
import PremiseService from '../../../services/bioplus-services/premise';
import GeofenceService from '../../../services/bioplus-services/geofence';
import LogBookService from '../../../services/bioplus-services/logBook';
import { useCompany } from '../../../hooks/CompanyContext';
import CameraOne from '../../../assets/PNG/camera-1.png';
import CameraTwo from '../../../assets/PNG/camera-2.png';

import { IntlMessages } from '../../../helper/langHelper';
import { CenterContainer, TooltipBox } from '../../../Components/uielements/tooltip/tooltip.style';
import { useNavigate } from 'react-router-dom';
import DashboardTable from './table/dashboardTable';

const PartnerDashboard = () => {
  const userContext = useUserContext();
  const companyContext = useCompany();
  const userDetails = useUserContext()?.user;
  // const [isShowLinksModal, setIsShowLinksModal] = useState(false);
  // const partnerId = userContext.company?.companyId?.id;
  const partnerId = userContext.company?.partnerId;
  const companyFilter = companyContext?.company?._id;
  const companyCountQuery = useQuery(['companyCount', companyFilter], () =>
    CompanyService.countByPartner(partnerId, { ...(companyFilter && { companyId: companyFilter }) })
  );
  const userCountQuery = useQuery(['userCount', companyFilter, userContext], () =>
    UserService.countByPartner(partnerId, { ...(companyFilter && { companyId: companyFilter }) })
  );
  const premiseCountQuery = useQuery(['premiseCount', companyFilter, userContext], () =>
    PremiseService.countByPartner(partnerId, { ...(companyFilter && { companyId: companyFilter }) })
  );
  const geofenceCountQuery = useQuery(['geofenceCount', companyFilter, userContext], () =>
    GeofenceService.countByPartner(partnerId, {
      ...(companyFilter && { companyId: companyFilter }),
    })
  );
  const logRecordCountQuery = useQuery(['logBookCount', companyFilter, userContext], () =>
    LogBookService.countByPartner(partnerId, { ...(companyFilter && { companyId: companyFilter }) })
  );
  //   const notificationCountQuery = useQuery(['notificationCount'], () => notificationCountByPartner(partnerId));

  const query = useQuery(['logBookEntries'], () =>
    LogbookService.listByPartner(
      partnerId,
      {
        companyId: companyFilter,
        fromDate: DateUtils.last7Days(),
        toDate: DateUtils.today(),
      },
      0,
      4
    )
  );
  const tableData = query?.data ?? [];
  const navigate = useNavigate();

  const handleNaviagte = (path) => {
    if (path) {
      navigate(path);
    }
  };
  // hover tooltip
  const [showTooltip, setIsHovered] = useState(false);
  const [showTooltipUser, setIsHoveredUser] = useState(false);
  const [showTooltipPremise, setIsHoveredPremise] = useState(false);
  const [showTooltipGeofence, setIsHoveredGeofence] = useState(false);
  const [showTooltipLogBook, setIsHoveredLogBook] = useState(false);
  // const [showTooltipNotification, setIsHoveredNotification] = useState(false);

  const handleMouseEnter = (onSet) => {
    onSet(true);
  };
  const handleMouseLeave = (onSet) => {
    onSet(false);
  };

  return (
    <DashboardContainer>
      {/* hearder section */}
      <DashboardHeaderContainer>
        <DashboardHeaderTitle>
          <IntlMessages id="header.dashboard" />
        </DashboardHeaderTitle>
      </DashboardHeaderContainer>
      {/* card section */}
      <DashboardCardContainer>
        <DashboardContainerLeft>
          <DashboardCard>
            {userDetails?.camera1 ? (
              <ImageWrapper>
                <Image src={`data:image/png;base64,${userDetails?.camera1}`} alt="Camera" />
              </ImageWrapper>
            ) : (
              <ImageWrapper>
                <Image src={CameraOne} alt="camera image" />
              </ImageWrapper>
            )}
            <LogoTitle>CAMERA #1</LogoTitle>
          </DashboardCard>
          <DashboardCard>
            {userDetails?.camera2 ? (
              <ImageWrapper>
                <Image src={`data:image/png;base64,${userDetails?.camera2}`} alt="Camera" />
              </ImageWrapper>
            ) : (
              <ImageWrapper>
                <Image src={CameraTwo} alt="camera image" />
              </ImageWrapper>
            )}
            <LogoTitle>CAMERA #2</LogoTitle>
          </DashboardCard>
        </DashboardContainerLeft>
        <DashboardContainerRight>
          <DashboardContainerRightTitle>CAMERA #1</DashboardContainerRightTitle>
          <DashboardContainerRightTitle>CAMERA #2</DashboardContainerRightTitle>
        </DashboardContainerRight>
      </DashboardCardContainer>
      {/* table view */}
      <DashboardTableContainer>
        <DashboardTableView>
          <DashboardTableContent>
            <Label weight="bold" size="header1" color="lightGreen" transform="uppercase">
              <IntlMessages id="dashboard.visitors" />
            </Label>
            <DashboardTable data={tableData} />
          </DashboardTableContent>
        </DashboardTableView>
        <DashboardCountView>
          <Label weight="bold" size="header1" color="lightGreen" transform="uppercase">
            <IntlMessages id="dashboard.counts" />
          </Label>
          <DashboardCountContainer>
            <DashboardCountContainerRight>
              <DashboardCountCard onClick={() => handleNaviagte('/companies')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHovered)}
                    onMouseLeave={() => handleMouseLeave(setIsHovered)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{companyCountQuery.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="table.col.account.owner" />
                </DashboardCountCardRight>
                {showTooltip && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="companies.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              <DashboardCountCard onClick={() => handleNaviagte('/roles')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredUser)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredUser)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{userCountQuery?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.roles" />
                </DashboardCountCardRight>
                {showTooltipUser && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="user.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              <DashboardCountCard onClick={() => handleNaviagte('/premises')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredPremise)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredPremise)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{premiseCountQuery?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.premises" />
                </DashboardCountCardRight>
                {showTooltipPremise && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="premise.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
            </DashboardCountContainerRight>
            <DashboardCountContainerLeft>
              <DashboardCountCard onClick={() => handleNaviagte('/geofences')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredGeofence)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredGeofence)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{geofenceCountQuery?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.geofences" />
                </DashboardCountCardRight>{' '}
                {showTooltipGeofence && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="geofence.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              <DashboardCountCard onClick={() => handleNaviagte('/logrecords')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredLogBook)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredLogBook)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{logRecordCountQuery?.data ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.logRecords" />
                </DashboardCountCardRight>{' '}
                {showTooltipLogBook && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="logbook.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              {/* <DashboardCountCard onClick={() => handleNaviagte('/notifications')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredNotification)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredNotification)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>0</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.notifications" />
                </DashboardCountCardRight>{' '}
                {showTooltipNotification && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                                 background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label >
                        <IntlMessages id="notification.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard> */}
            </DashboardCountContainerLeft>
          </DashboardCountContainer>
        </DashboardCountView>
      </DashboardTableContainer>
    </DashboardContainer>
  );
};

export default PartnerDashboard;
